import React, { createContext, useContext, useState, useEffect } from 'react';
import { officeAPI } from '../services/api';

const OfficeAuthContext = createContext(null);

export const OfficeAuthProvider = ({ children }) => {
  const [session, setSession] = useState(null); // { user, office, officeRole }
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // M-05: no localStorage token — rely on httpOnly cookie sent automatically
    officeAPI.me()
      .then((res) => setSession(res.data.data))
      .catch(() => setSession(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await officeAPI.login({ email, password });
    const { user, office, officeRole } = res.data.data;
    // Cookie set by server; no localStorage write needed
    setSession({ user, office, officeRole });
    return { user, office, officeRole };
  };

  const logout = async () => {
    try {
      await officeAPI.logout(); // increments tokenVersion + clears cookie server-side
    } catch {
      // ignore network errors — clear local state regardless
    }
    setSession(null);
  };

  return (
    <OfficeAuthContext.Provider value={{ session, login, logout, loading }}>
      {children}
    </OfficeAuthContext.Provider>
  );
};

export const useOfficeAuth = () => useContext(OfficeAuthContext);
